import type { SVGProps } from "react";
const SenecPictogramFastCharger = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 5C9 3.34315 10.3431 2 12 2H28.8005C30.5697 2 31.9547 3.52318 31.787 5.28443L31.5305 7.97679L39.0371 35.3537C39.6885 37.7292 38.1084 40.1375 35.67 40.4859C33.2052 40.838 31 38.9254 31 36.4356V29.4599L29.5989 28.259L27.9093 46H9V30H14.1C14.5633 27.7178 16.581 26 19 26H21V28H23V30H19V28C17.3431 28 16 29.3431 16 31C16 32.6569 17.3431 34 19 34V32H23V34H21V36H19C16.581 36 14.5633 34.2822 14.1 32H11V40H22C22.5523 40 23 40.4477 23 41C23 41.5523 22.5523 42 22 42H11V44H26.0907L29.424 9H17V7H29.6145L29.796 5.09481C29.8519 4.50773 29.3902 4 28.8005 4H12C11.4477 4 11 4.44772 11 5V26C11 26.5523 10.5523 27 10 27C9.44772 27 9 26.5523 9 26V5ZM29.8308 25.8236L30.9959 13.5903L37.1083 35.8826C37.4413 37.0969 36.6336 38.3279 35.3871 38.506C34.1272 38.686 33 37.7083 33 36.4356V28.5401L29.8308 25.8236Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 15C14.8954 15 14 15.8954 14 17V20C14 21.1046 14.8954 22 16 22H23C24.1046 22 25 21.1046 25 20V17C25 15.8954 24.1046 15 23 15H16ZM16 17H23V20H16V17Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramFastCharger;
